import { Award, FileText, Linkedin } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { useQualiopi } from '@/hooks/useQualiopi';
import { QualiopiLogo } from '@/components/ui/QualiopiLogo';
import { FranceNumLogo } from '@/components/ui/FranceNumLogo';
import { ToolLogo } from '@/components/ui/ToolLogo';

export const SiteFooter = () => {
  const { getComplaintFormUrl } = useQualiopi();
  const complaintUrl = getComplaintFormUrl();
  const location = useLocation();
  
  // Masquer le logo sur les pages de formations individuelles (conformité Qualiopi)
  const isIndividualCoursePage = location.pathname.startsWith('/formation/') 
    && location.pathname !== '/formations';

  return (
    <footer className="border-t border-border bg-background" aria-label="Pied de page">
<div className="container-premium py-8">
  <div className="flex items-center justify-center gap-3 text-sm">
    <a
      href="https://www.linkedin.com/company/nocodeo/"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Suivre NoCodeo sur LinkedIn"
      className="inline-flex items-center gap-2 text-muted-foreground hover:text-primary transition-colors"
    >
      <Linkedin className="h-5 w-5 text-primary" aria-hidden="true" />
      <span className="font-medium">Suivez NoCodeo sur LinkedIn</span>
    </a>
  </div>
  
  {/* Logo Qualiopi et France Num - Masqués sur les pages de formations individuelles */}
  {!isIndividualCoursePage && (
    <div className="mt-6 flex flex-col md:flex-row items-center justify-center gap-8">
      <div className="flex flex-col items-center gap-2">
        <img 
          src="/images/nocodeo-icon.png"
          alt="NoCodeo"
          className="h-24 w-auto object-contain"
        />
        <div className="text-center space-y-1">
          <div className="text-sm font-semibold text-foreground">NoCodeo</div>
          <div className="text-xs text-muted-foreground">
            Organisme de formation déclaré
          </div>
          <div className="text-xs text-muted-foreground">
            N° : 11931186393
          </div>
        </div>
      </div>
      <div className="flex flex-col items-center gap-2">
        <QualiopiLogo size="md" showMention={true} certificateUrl="/documents/certificat-qualiopi.pdf" />
        <Link
          to="/certificat-qualiopi"
          target="_blank"
          rel="noopener noreferrer"
          className="text-xs text-primary hover:underline font-medium inline-flex items-center gap-1"
        >
          <FileText className="h-3 w-3 inline mr-1" /> Consulter notre certificat Qualiopi
        </Link>
      </div>
      <div className="flex flex-col items-center gap-2">
        <FranceNumLogo size="md" showMention={true} />
      </div>
      <div className="flex flex-col items-center gap-2">
        <div className="flex items-center gap-2 p-3 rounded-lg bg-muted/50">
          <ToolLogo name="Airtable" size={28} />
          <ToolLogo name="Softr" size={28} />
        </div>
        <Link
          to="/certifications-outils"
          className="text-xs text-primary hover:underline font-medium inline-flex items-center gap-1"
        >
          <Award className="h-3 w-3" /> Certifications outils
        </Link>
      </div>
    </div>
  )}
  
  <div className="mt-6 flex items-center justify-center gap-4 text-xs text-muted-foreground">
    <Link to="/reglement-interieur" className="hover:text-primary transition-colors">Règlement intérieur</Link>
    <span aria-hidden>•</span>
    <Link to="/conditions-generales-utilisation" className="hover:text-primary transition-colors">Conditions générales d'utilisation</Link>
    {complaintUrl && (
      <>
        <span aria-hidden>•</span>
        <a 
          href={complaintUrl} 
          target="_blank" 
          rel="noopener noreferrer" 
          className="hover:text-primary transition-colors text-amber-600 font-medium"
        >
          Réclamation
        </a>
      </>
    )}
  </div>
  <div className="mt-4 flex items-center justify-center gap-4 text-xs text-muted-foreground">
    <Link to="/mentions-legales" className="hover:text-primary transition-colors">Mentions légales</Link>
    <span aria-hidden>•</span>
    <Link to="/politique-confidentialite" className="hover:text-primary transition-colors">Politique de confidentialité</Link>
    <span aria-hidden>•</span>
    <Link to="/cgv" className="hover:text-primary transition-colors">CGV</Link>
  </div>
  
  <div className="mt-3 text-center text-xs text-muted-foreground/70">
    Les logos et marques tierces appartiennent à leurs propriétaires respectifs. NoCodeo est un organisme de formation indépendant.
  </div>
</div>
    </footer>
  );
};
